// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getContratos as listContratosAPI,
    getContrato as getContratoAPI,
    addContrato as addContratoAPI,
    updateContrato as updateContratoAPI
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { contratosApiResponseError, contratosApiResponseSuccess } from './actions';
import { ContratosActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getContrato({ payload: { id } }) {
    try {
        const response = yield call(getContratoAPI, id );
        const contrato = response.data.data;
        // NOTE - You can change this according to response format from your api
        // api.setLoggedInUser(user);
        // setAuthorization(user['token']);
        yield put(contratosApiResponseSuccess(ContratosActionTypes.GET_CONTRATO, contrato));
    } catch (error) {
        yield put(contratosApiResponseError(ContratosActionTypes.GET_CONTRATO, error));
        // api.setLoggedInUser(null);
        // setAuthorization(null);
    }
}

/**
 * List contactos
 */
function* listContratos() {
    try {
        const response = yield call(listContratosAPI);
        const listaContratos = response.data.data;
        yield put(contratosApiResponseSuccess(ContratosActionTypes.LIST_CONTRATOS, listaContratos));
    } catch (error) {
        yield put(contratosApiResponseError(ContratosActionTypes.LIST_CONTRATOS, error));
    }
}

function* addContrato({payload:contract}) {
    try{
        const response = yield call(addContratoAPI,{...contract})
        const contrato = response.data.id

        yield put(contratosApiResponseSuccess(ContratosActionTypes.CREATE_CONTRATO, contrato))
    } catch(error){
        yield put(contratosApiResponseError(ContratosActionTypes.CREATE_CONTRATO,error))
    }
}

function* updateContrato({payload:contract}){
    try{
        const response = yield call(updateContratoAPI,{...contract})
        const contrato = response.data.data

        yield put(contratosApiResponseSuccess(ContratosActionTypes.UPDATE_CONTRATO,contrato))
    } catch(error){
        yield put(contratosApiResponseError(ContratosActionTypes.UPDATE_CONTRATO,error))
    }
}


export function* watchGetContrato(): any {
    yield takeEvery(ContratosActionTypes.GET_CONTRATO, getContrato);
}

export function* watchListContratos(): any {
    yield takeEvery(ContratosActionTypes.LIST_CONTRATOS, listContratos);
}

export function* watchAddContrato(): any{
    yield takeEvery(ContratosActionTypes.CREATE_CONTRATO, addContrato)
}

export function* watchUpdateContrato(): any{
    yield takeEvery(ContratosActionTypes.UPDATE_CONTRATO,updateContrato)
}


function* contratosSaga(): any {
    yield all([
        fork(watchGetContrato),
        fork(watchListContratos),
        fork(watchAddContrato),
        fork(watchUpdateContrato),
    ]);
}

export default contratosSaga;
